import React, { useState } from 'react'
import { Icon } from 'semantic-ui-react'
import { FormInput, t } from 'shared'
import { FormInputProps } from './inputs'

export const PasswordInput = ({ form, field = 'password', title }: FormInputProps) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <FormInput
      form={form}
      field={field}
      title={title ?? t('attributes.password')}
      type={showPassword ? 'text' : 'password'}
      icon={
        <Icon
          name={showPassword ? 'eye slash' : 'eye'}
          link
          style={{ color: '#848484', opacity: 1 }}
          onClick={() => setShowPassword(showPassword ? false : true)}
        />
      }
      fluid
    />
  )
}
